import { useEffect } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ManagerBottomNavigationBar from '../../../components/ManagerBottomNavigationBar';
import { PendingActivationCard } from '../../../components/PendingActivationCard';
import { useInventory } from '../../../store/inventory';

export function ManagerActivationsPage() {
  const { t } = useTranslation();
  const {
    pendingActivations,
    loading,
    error,
    refreshPendingActivations,
    processActivation,
  } = useInventory();

  useEffect(() => {
    refreshPendingActivations();
  }, [refreshPendingActivations]);

  const handleApproveActivation = async (inventoryItemId: string) => {
    await processActivation(inventoryItemId, 'approve');
  };

  const handleDenyActivation = async (inventoryItemId: string) => {
    await processActivation(inventoryItemId, 'deny');
  };

  return (
    <div className="bg-white min-vh-100 d-flex flex-column">
      <Container fluid className="flex-grow-1 pb-5">
        <div className="d-flex justify-content-between align-items-center p-4 mb-4">
          <h1 className="text-dark h4 fw-bold">{t('manager.activations.title')}</h1>
        </div>

        <div className="px-4">
          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          {loading && pendingActivations.length === 0 && (
            <div className="text-center py-5">
              <p>{t('common.loading')}</p>
            </div>
          )}

          {!loading && pendingActivations.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">{t('manager.activations.no_pending')}</p>
            </div>
          )}

          {pendingActivations.length > 0 && (
            <Row>
              {pendingActivations.map((item) => (
                <Col key={item._id} xs={12} sm={6} md={4} lg={3} className="mb-3">
                  <PendingActivationCard
                    item={item}
                    onApprove={handleApproveActivation}
                    onDeny={handleDenyActivation}
                    loading={loading}
                  />
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Container>

      <ManagerBottomNavigationBar />
    </div>
  );
}